<template>
	<el-upload class="avatar-uploader" :action="config.apiurl + '/api/common/upload'" :show-file-list="false" :on-success="upAS" :before-upload="upABS" align="left">
		<img v-if="value" :src="config.apiurl+value" class="avatar border">
		<i v-else class="el-icon-plus avatar-uploader-icon border"></i>
	</el-upload>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods:{
			upAS(res, file) {
				var o=document.createElement('input');
				o.input=()=>{
					this.$emit('input', res.data.url);
				}
				o.input();
			},
			upABS(file) {
				const isJPG = file.type === 'image/jpeg'||file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 4;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			}
		},
		props: {
			value: {
				type: String,
				default: ''
			}
		},
		mounted: function () {
			
		},
		computed:{
			
		}
	}
</script>

<style scoped>
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 146px;
		height: 146px;
		line-height: 146px;
		text-align: center;
	}
	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}
	.border{
		border: 1px solid #dcdfe6;
		border-radius:4px;
	}
</style>
